module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "content-top"
  }, [(_vm.$auth.user().role === 'root') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.add = true
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("\n      " + _vm._s(_vm.$t('pages.apps.addApp')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "float": "right",
      "width": "260px"
    },
    attrs: {
      "placeholder": _vm.$t('pages.apps.enter_app_name'),
      "icon": "search"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.filteredApps
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "width": "80",
      "label": _vm.$t('pages.apps.id')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "width": "140",
      "label": _vm.$t('pages.apps.name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "description",
      "label": _vm.$t('pages.apps.description')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "160",
      "lable": _vm.$t('pages.apps.app_key')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', {
          staticClass: "code"
        }, [_vm._v("App Key: "), _c('span', [_vm._v(_vm._s(scope.row.app_key))])]), _vm._v(" "), _c('p', {
          staticClass: "code"
        }, [_vm._v("App Secret: "), _c('span', [_vm._v(_vm._s(scope.row.app_secret))])]), _vm._v(" "), _c('p', {
          staticClass: "code"
        }, [_vm._v("Api Key: "), _c('span', [_vm._v(_vm._s(scope.row.api_key))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "align": "center",
      "label": _vm.$t('pages.apps.is_active')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.is_active) ? _c('i', {
          staticClass: "el-icon-check"
        }) : _c('i', {
          staticClass: "el-icon-close"
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "align": "center",
      "label": _vm.$t('common.operation')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.manageApp(scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('pages.apps.manage')))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('pages.apps.addApp')
    },
    on: {
      "close": _vm.resetAdd
    },
    model: {
      value: (_vm.add),
      callback: function($$v) {
        _vm.add = $$v
      },
      expression: "add"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.appForm,
      "rules": _vm.addFromRule,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('pages.apps.name')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.appForm.name),
      callback: function($$v) {
        _vm.$set(_vm.appForm, "name", $$v)
      },
      expression: "appForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.apps.base_url'),
      "prop": "base_url"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.appForm.base_url),
      callback: function($$v) {
        _vm.$set(_vm.appForm, "base_url", $$v)
      },
      expression: "appForm.base_url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "description",
      "label": _vm.$t('pages.apps.description')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addApp($event)
      }
    },
    model: {
      value: (_vm.appForm.description),
      callback: function($$v) {
        _vm.$set(_vm.appForm, "description", $$v)
      },
      expression: "appForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addApp
    }
  }, [_vm._v(_vm._s(_vm.$t('common.save')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-997fad2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Applications.vue
// module id = 394
// module chunks = 1